export default "__VITE_ASSET__nDuUqaP___"